import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
    RiAlertLine,
    RiFileList3Line,
    RiGroupLine,
    RiShoppingBagLine,
    RiStackLine,
    RiTruckLine,
} from 'react-icons/ri';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_DASHBOARD_SUMMARY_QUERY_KEY = '3rd-party-management-fetch-eudr-dashboard-summary';

const WIDGET_CONFIG = [
    {
        key: 'totalSuppliers',
        titleKey: 'Total Suppliers',
        icon: RiGroupLine,
    },
    {
        key: 'totalShipments',
        titleKey: 'Total Shipments',
        icon: RiTruckLine,
    },
    {
        key: 'ddsSubmitted',
        titleKey: 'DDS Submitted',
        icon: RiFileList3Line,
    },
    {
        key: 'totalRelevantProducts',
        titleKey: 'Total Relevant Products',
        icon: RiShoppingBagLine,
    },
    {
        key: 'totalRelevantLots',
        titleKey: 'Total Relevant Lots',
        icon: RiStackLine,
    },
    {
        key: 'highRiskSuppliers',
        titleKey: 'High Risk Suppliers',
        icon: RiAlertLine,
    },
];

const useSummaryWidgets = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_DASHBOARD_SUMMARY_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchSummary();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR dashboard summary data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            widgets: null,
        };
    }

    return {
        ...query,
        widgets: WIDGET_CONFIG.map((config) => ({
            key: config.key,
            title: t(config.titleKey),
            value: Number(data[config.key]) || 0,
            icon: config.icon,
        })),
    };
};

export default useSummaryWidgets;
